export default "__VITE_ASSET__d41ccce5__"